<template>
  <div class="footer-wrapper">
    <div class="new-home-footer">
      <span class="txt">主办单位：中国（海南）改革发展研究院 琼10200862号</span>
      <span
        class="txt clickable"
        @click="turnToBigScreen"
      >信息视窗</span>
      <span
        class="txt clickable"
        @click="turnToAboutUs"
      >关于我们</span>
      <span
        class="txt clickable"
        @click="turnToCopyright"
      >版权声明</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CirdFooter',
  methods: {
    turnToAboutUs () {
      let id = 'abd44117-1434-4f2f-a86d-aec7739024c9'
      let { href } = this.$router.resolve({
        path: '/aboutUs/' + id
      })
      window.open(href)
    },
    turnToCopyright () {
      let { href } = this.$router.resolve({
        path: '/aboutUs/' + '325a5a4f-600d-459c-a2db-ed17c8fb51df'
      })
      window.open(href)
    },
    turnToBigScreen () {
      window.open('http://datacenter.reformdata.org:8080/#/nav')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/modules/common/footer/footer.out.vue